<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="550"
      :mask-closable="true"
      @on-close="changeModalCancel">
      <div>
        <Form ref="changeForm" :model="changeForm" :label-width="85" :rules="changeRule">
          <FormItem label="名称" prop="name">
            <Input v-model="changeForm.name" />
          </FormItem>
          <FormItem label="执行主机类型" prop="os">
            <Select v-model="changeForm.os" style="width:100%">
              <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <div v-if="changeForm.os === 0">
            <FormItem label="触发时间" prop="transCron">
              <Input v-model="changeForm.transCron" placeholder="Cron格式, 如: 1 * * * *" />
            </FormItem>
          </div>
          <div v-else-if="changeForm.os === 1">
            <FormItem label="触发时间" prop="frequency">
              <Select v-model="changeForm.frequency" style="width:250px">
                <Option v-for="item in frequencyList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <div v-if="changeForm.frequency !== 'boot'">
              <Row>
                <Col span="12">
                  <FormItem label="开始时间" prop="start_time">
                    <DatePicker type="datetime" v-model="changeForm.start_time"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem label="重复执行间隔" :label-width="100" prop="start_time">
                    <Input v-model="changeForm.repetition_number">
                    <Select v-model="changeForm.repetition_unit" slot="append" style="width: 70px">
                      <Option v-for="item in repetitionUnitList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    </Input>
                  </FormItem>
                </Col>
              </Row>
            </div>
            <div v-if="changeForm.frequency === 'daily'">
              <FormItem label="" prop="detach_day">
                <Input v-model="changeForm.detach_day">
                <span slot="prepend">每隔</span>
                <span slot="append">天执行一次</span>
                </Input>
              </FormItem>
            </div>
            <div v-if="changeForm.frequency === 'weekly'">
              <Row>
                <Col span="16">
                  <FormItem label="" prop="detach_week">
                    <Input v-model="changeForm.detach_week">
                    <span slot="prepend">每隔</span>
                    <span slot="append">周的</span>
                    </Input>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="" :label-width="10" prop="days_of_week_list">
                    <Select multiple v-model="changeForm.days_of_week_list">
                      <Option value="monday">星期一执行</Option>
                      <Option value="tuesday">星期二执行</Option>
                      <Option value="wednesday">星期三执行</Option>
                      <Option value="thursday">星期四执行</Option>
                      <Option value="friday">星期五执行</Option>
                      <Option value="saturday">星期六执行</Option>
                      <Option value="sunday">星期日执行</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </div>
            <div v-if="changeForm.frequency === 'monthly'">
              <Row>
                <Col span="14">
                  <FormItem label="月" :label-width="150" prop="months_of_year_list">
                    <Select multiple v-model="changeForm.months_of_year_list">
                      <Option value="january">一月</Option>
                      <Option value="february">二月</Option>
                      <Option value="march">三月</Option>
                      <Option value="april">四月</Option>
                      <Option value="may">五月</Option>
                      <Option value="june">六月</Option>
                      <Option value="july">七月</Option>
                      <Option value="august">八月</Option>
                      <Option value="september">九月</Option>
                      <Option value="october">十月</Option>
                      <Option value="november">十一月</Option>
                      <Option value="december">十二月</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem label="日" :label-width="30" prop="days_of_month_list">
                    <Select multiple v-model="changeForm.days_of_month_list">
                      <Option value="1">1</Option>
                      <Option value="2">2</Option>
                      <Option value="3">3</Option>
                      <Option value="4">4</Option>
                      <Option value="5">5</Option>
                      <Option value="6">6</Option>
                      <Option value="7">7</Option>
                      <Option value="8">8</Option>
                      <Option value="9">9</Option>
                      <Option value="10">10</Option>
                      <Option value="11">11</Option>
                      <Option value="12">12</Option>
                      <Option value="13">13</Option>
                      <Option value="14">14</Option>
                      <Option value="15">15</Option>
                      <Option value="16">16</Option>
                      <Option value="17">17</Option>
                      <Option value="18">18</Option>
                      <Option value="19">19</Option>
                      <Option value="20">20</Option>
                      <Option value="21">21</Option>
                      <Option value="12">22</Option>
                      <Option value="23">23</Option>
                      <Option value="24">24</Option>
                      <Option value="25">25</Option>
                      <Option value="26">26</Option>
                      <Option value="27">27</Option>
                      <Option value="28">28</Option>
                      <Option value="29">29</Option>
                      <Option value="30">30</Option>
                      <Option value="31">31</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </div>
          <FormItem label="触发器" prop="trigger">
            <Input
              v-model="changeForm.trigger"
              readonly
              search
              enter-button="生成"
              placeholder="请点击生成按钮"
              @on-search="produce"
            ></Input>
          </FormItem>
          <FormItem label="执行">
            <RadioGroup v-model="changeForm.type">
              <Radio label="order">指令</Radio>
              <Radio label="script">脚本</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="指令" prop="order" v-if="changeForm.type === 'order'">
            <Input v-model="changeForm.order" placeholder="请填写执行的命令" />
          </FormItem>
          <FormItem label="脚本" prop="script" v-else-if="changeForm.type === 'script'">
            <Select v-model="changeForm.script">
              <Option v-for="item in allScriptList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="脚本参数" v-show="changeForm.type === 'script'">
            <Input placeholder="请输入脚本参数" :maxlength="512" v-model="changeForm.params"/>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input type="textarea" v-model="changeForm.remark" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card>
      <Row>
        <Col span="24" :lg="22">
          <Form :model="searchForm" ref="searchForm" :label-width="60" inline label-position="left">
            <FormItem label="名称" :label-width="40">
              <Input v-model="searchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="系统类型">
              <Select v-model="searchForm.os" style="min-width:200px" clearable placeholder="">
                <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getCronData()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :lg="2">
          <Button
            style="float: right;"
            @click="changeModal = true; changeModalTitle='添加计划任务'"
            type="primary"
            :style="{marginBottom: '10px'}"
            v-show="isCronAdd"
            icon="md-add">添加计划任务</Button>
        </Col>
      </Row>
      <Table
        border
        :loading="cronTableLoading"
        :data="cron.data"
        :columns="cron.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="cron.count"
            :current="cron.page"
            :page-size="cron.size"
            @on-change="getCronData"></page>
        </div>
      </div>
    </Card>
    <Drawer title="修改记录" :closable="true" width="550" v-model="LogsModel">
      <Logs :logs="RevisionLogs" />
    </Drawer>
  </div>
</template>

<script>
import { getOpsCenterCron, changeOpsCenterCron, deleteOpsCenterCron,
  getContentTypeId, getRevisionLogs, getOpsCenterAllScript } from '@/api/opscenter'
import Logs from './Logs'

export default {
  name: 'cron-manage',
  components: {
    'Logs': Logs
  },
  data () {
    return {
      isCronAdd: false,
      isCronEdit: false,
      isCronDelete: false,
      isCronView: false,
      changeModal: false,
      cronTableLoading: false,
      changeModalTitle: '添加计划任务',
      changeForm: {
        id: 0,
        name: '',
        os: 0,
        transCron: '',
        frequency: 'daily',
        start_time: '',
        repetition_number: '',
        repetition_unit: 'M',
        detach_day: '',
        detach_week: '',
        days_of_week_list: [],
        months_of_year_list: [],
        days_of_month_list: [],
        trigger: '',
        type: 'order',
        order: '',
        script: '',
        params: '',
        remark: ''
      },
      allScriptList: [],
      changeRule: {
        name: { required: true, message: '名称不能为空', trigger: 'blur' },
        trigger: { required: true, message: '请生成触发器', trigger: 'blur' }
      },
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      frequencyList: [
        {
          value: 'daily',
          label: '每天'
        },
        {
          value: 'weekly',
          label: '每周'
        },
        {
          value: 'monthly',
          label: '每月'
        },
        {
          value: 'time',
          label: '一次'
        },
        {
          value: 'boot',
          label: '计算机启动时'
        }
      ],
      repetitionUnitList: [
        {
          value: 'M',
          label: '分钟'
        },
        {
          value: 'H',
          label: '小时'
        },
        {
          value: 'D',
          label: '天'
        }
      ],
      cron: {
        data: [],
        columns: [
          {
            title: 'ID',
            align: 'center',
            key: 'id',
            minWidth: 60
          },
          {
            title: '名称',
            align: 'center',
            key: 'name',
            minWidth: 140
          },
          {
            title: '执行主机系统类型',
            align: 'center',
            key: 'os',
            minWidth: 140,
            render: (h, params) => {
              let osChoices = {
                0: 'Linux',
                1: 'Windows'
              }
              let iconType = 'logo-tux'
              if (params.row.os === 0 || params.row.os === 1) {
                if (params.row.os === 1) {
                  iconType = 'logo-windows'
                }
                return h('div', [
                  h('Icon', {
                    props: {
                      type: iconType,
                      size: 18
                    }
                  }), ' ' + osChoices[params.row.os]
                ])
              } else {
                return ''
              }
            }
          },
          {
            title: '类型',
            align: 'center',
            key: 'type',
            minWidth: 85,
            render: (h, params) => {
              let typeChoices = {
                'order': '执行指令',
                'script': '执行脚本'
              }
              if (params.row.type === 'order' || params.row.type === 'script') {
                return h('div', typeChoices[params.row.type])
              } else {
                return ''
              }
            }
          },
          {
            title: '创建人',
            align: 'center',
            key: 'user_full_name',
            minWidth: 100
          },
          {
            title: '创建时间',
            align: 'center',
            key: 'create_time_format',
            minWidth: 150
          },
          {
            title: '正在运行的主机',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              let color = '#7c7c7c'
              if (params.row.server.length > 0) {
                color = 'green'
              }
              return h('div', {
                style: {
                  'color': color
                }
              }, params.row.server.length)
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 230,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'cron_detail',
                        params: { 'id': params.row.id }
                      })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.revisionLog(params.row.id)
                      this.LogsModel = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  style: {
                    display: this.isCronEdit ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.modifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      if (params.row.server.length > 0) {
                        this.$Notice.warning({
                          title: '不允许',
                          desc: '当前计划任务已绑定服务器，请先解绑后再删除！'
                        })
                        return false
                      }
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      display: this.isCronDelete ? 'inline-block' : 'none'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      contentTypeId: '',
      LogsModel: false,
      RevisionLogs: [],
      searchForm: {
        name: '',
        os: ''
      }
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getCronData()
    getContentTypeId({ 'model_name': 'Cron' }).then(res => {
      let result = res.data
      this.contentTypeId = result.content_type_id
    })
    this.allScript()
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_cron') > -1) {
        this.isCronAdd = true
      } else {
        this.isCronAdd = false
      }
      if (permissions.indexOf('change_cron') > -1) {
        this.isCronEdit = true
      } else {
        this.isCronEdit = false
      }
      if (permissions.indexOf('delete_cron') > -1) {
        this.isCronDelete = true
      } else {
        this.isCronDelete = false
      }
      if (permissions.indexOf('view_cron') > -1) {
        this.isCronView = true
      } else {
        this.isCronView = false
      }
    },
    changeModalCancel () {
      this.changeFormReset()
      this.changeModal = false
    },
    changeFormReset () {
      this.changeForm.id = 0
      this.changeForm.name = ''
      this.changeForm.os = 0
      this.changeForm.transCron = ''
      this.changeForm.frequency = 'daily'
      this.changeForm.start_time = ''
      this.changeForm.repetition_number = ''
      this.changeForm.repetition_unit = 'M'
      this.changeForm.detach_day = ''
      this.changeForm.detach_week = ''
      this.changeForm.days_of_week_list = []
      this.changeForm.months_of_year_list = []
      this.changeForm.days_of_month_list = []
      this.changeForm.trigger = ''
      this.changeForm.type = 'order'
      this.changeForm.order = ''
      this.changeForm.script = ''
      this.changeForm.params = ''
      this.changeForm.remark = ''
    },
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          changeOpsCenterCron(this.changeForm, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getCronData(this.cron.page)
            this.changeFormReset()
            this.changeModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getCronData (value = 1) {
      this.cron.page = value
      let params = {
        size: this.cron.size,
        page: this.cron.page,
        name: this.searchForm.name,
        os: this.searchForm.os
      }
      getOpsCenterCron(params).then(res => {
        this.cron.data = res.data.results
        this.cron.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取计划任务列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取计划任务列表失败！服务器无响应'
          })
        }
      })
    },
    modifyOpen (row) {
      if (row.server.length > 0) {
        this.$Notice.warning({
          title: '不允许',
          desc: '当前计划任务已绑定服务器，请先解绑后再编辑！'
        })
        return false
      }
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.os = row.os
      this.changeForm.type = row.type
      this.changeForm.order = row.order
      if (row.script) {
        this.changeForm.script = row.script.id
        this.changeForm.params = row.params
      }
      this.changeForm.trigger = row.trigger
      this.changeForm.remark = row.remark
      this.changeModalTitle = '编辑计划任务：' + row.name
      this.changeModal = true
    },
    delete (row) {
      deleteOpsCenterCron(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getCronData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    produce () {
      let triggers = ''
      if (this.changeForm.os === 1) {
        let startTime = ''
        if (this.changeForm.start_time) {
          let date = new Date(this.changeForm.start_time)
          startTime = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + ' ' +
            date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
        }
        if (this.changeForm.frequency === 'daily') {
          triggers = {
            'type': 'daily',
            'start_boundary': startTime,
            'days_interval': this.changeForm.detach_day
          }
          if (this.changeForm.repetition_number) {
            triggers['repetition'] = {
              'interval': 'PT' + this.changeForm.repetition_number + this.changeForm.repetition_unit
            }
          }
        } else if (this.changeForm.frequency === 'weekly') {
          triggers = {
            'type': 'weekly',
            'days_of_week': this.changeForm.days_of_week_list.join(','),
            'start_boundary': startTime,
            'weeks_interval': this.changeForm.detach_week
          }
          if (this.changeForm.repetition_number) {
            triggers['repetition'] = {
              'interval': 'PT' + this.changeForm.repetition_number + this.changeForm.repetition_unit
            }
          }
        } else if (this.changeForm.frequency === 'monthly') {
          triggers = {
            'type': 'monthly',
            'months_of_year': this.changeForm.months_of_year_list.join(','),
            'days_of_month': this.changeForm.days_of_month_list.join(','),
            'start_boundary': startTime
          }
          if (this.changeForm.repetition_number) {
            triggers['repetition'] = {
              'interval': 'PT' + this.changeForm.repetition_number + this.changeForm.repetition_unit
            }
          }
        } else if (this.changeForm.frequency === 'time') {
          triggers = {
            'type': 'time',
            'start_boundary': startTime
          }
          if (this.changeForm.repetition_number) {
            triggers['repetition'] = {
              'interval': 'PT' + this.changeForm.repetition_number + this.changeForm.repetition_unit
            }
          }
        } else if (this.changeForm.frequency === 'boot') {
          triggers = {
            'type': 'boot'
          }
        }
      } else {
        if (this.changeForm.transCron) {
          let regs = this.changeForm.transCron.split(' ')
          if (regs.length === 5) {
            triggers = {
              'minute': regs[0],
              'hour': regs[1],
              'day': regs[2],
              'month': regs[3],
              'weekday': regs[4]
            }
          } else {
            this.$Notice.error({
              title: '触发时间格式不对！',
              desc: '请注意格式：分钟 小时 天 月 星期'
            })
          }
        } else {
          this.$Notice.error({
            title: '请填写触发时间！'
          })
        }
      }
      if (triggers) {
        let triggersList = [triggers]
        this.changeForm.trigger = JSON.stringify(triggersList)
      }
    },
    allScript () {
      getOpsCenterAllScript().then(res => {
        this.allScriptList = res.data
      })
    },
    searchReset () {
      this.searchForm = {
        name: '',
        os: ''
      }
    },
    // 修改记录
    revisionLog (id) {
      let params = {
        object_id: id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
